@use '../../styles/util' as *;
@use '../../styles/global' as *;

.sol-icon-bubble {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-050, 8px);
  border-radius: 50%;
  gap: var(--spacing-050, 8px);

  &--default {
    background: var(--surface-base-secondary-alpha);
    color: var(--icon-base-subdued);

    &-opaque {
      background: var(--surface-base-secondary);
    }
  }

  &--transparent {
    background: transparent;
    color: var(--icon-base-subdued);
  }

  &--white {
    background: var(--surface-base-default);
    color: var(--icon-base-subdued);
  }

  &--accent {
    background: var(--surface-interaction-subdued-alpha);
    color: var(--icon-interaction-default);

    &-opaque {
      background: var(--surface-interaction-subdued);
    }
  }

  &--success {
    background: var(--surface-rag-success-subdued-alpha);
    color: var(--icon-rag-success-accessible);

    &-opaque {
      background: var(--surface-rag-success-subdued);
    }
  }

  &--danger {
    background: var(--surface-rag-danger-subdued-alpha);
    color: var(--icon-rag-danger-accessible);

    &-opaque {
      background: var(--surface-rag-danger-subdued);
    }
  }

  &--warning {
    background: var(--surface-rag-warning-subdued-alpha);
    color: var(--icon-rag-warning-accessible);

    &-opaque {
      background: var(--surface-rag-warning-subdued);
    }
  }

  &--padding-4 {
    padding: var(--spacing-025);
  }

  &--padding-6 {
    padding: 6px;
  }

  &--padding-8 {
    padding: var(--spacing-050);
  }

  &--padding-12 {
    padding: var(--spacing-075);
  }
}
